import React from 'react';
import {
  Card,
  Col,
  Modal,
  Row,
} from 'react-bootstrap';

import './index.scss';

export default function InstructionsModal({
  show,
  onHide,
}: {
  show: boolean,
  onHide: () => void,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      className="confirmation-dialog-modal"
    >
      <Modal.Header
        closeButton
        className="confirmation-dialog-modal-header"
      >
        <Modal.Title className="ms-4">
          INSTRUÇÕES
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-5 seasonal-comparator-instructions">
        <Row>
          <Col md={6}>
            <Card className="shadow-sm forecast-instruction-card mb-3 h-100">
              <Card.Header>COMO COMPARAR PREVISÕES SAZONAIS</Card.Header>
              <Card.Body>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-text">
                    Essa ferramenta permite comparar previsões entre modelos de mesma ou
                    diferente rodada. Para isso:
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number">1</div>
                  <div className="instruction-text">
                    Escolha a variável de interesse.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number instruction-marker">2</div>
                  <div className="instruction-text">
                    Defina a área de plotagem.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number instruction-marker">3</div>
                  <div className="instruction-text">
                    No
                    {' '}
                    <b>&quot;Modelo 1&quot;</b>
                    , selecione modelo, data de rodada e período de seleção.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number instruction-marker">4</div>
                  <div className="instruction-text">
                    Repita o mesmo para o
                    {' '}
                    <b>&quot;Modelo 2&quot;</b>
                    .
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number instruction-marker">5</div>
                  <div className="instruction-text">
                    Se necessário, ative o contorno de bacias hidrográficas ou as caixas de
                    cálculo de índices oceânicos na opção
                    {' '}
                    <b>&quot;Mostrar camadas&quot;</b>
                    .
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="shadow-sm forecast-instruction-card h-100">
              <Card.Header>COMO SALVAR PREFERÊNCIAS</Card.Header>
              <Card.Body>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-text">
                    Para salvar configurações frequentes:
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number">1</div>
                  <div className="instruction-text">
                    Selecione todas as opções desejadas no Painel de Controle.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number">2</div>
                  <div className="instruction-text">
                    Clique em
                    {' '}
                    <b>&quot;Salvar nova preferência&quot;</b>
                    .
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number instruction-marker">3</div>
                  <div className="instruction-text">
                    Dê um nome descritivo (ex.:
                    {' '}
                    <b>&quot;Previsão de chuva – ECMWF vs CFSv2&quot;</b>
                    ).
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number instruction-marker">4</div>
                  <div className="instruction-text">
                    Suas preferências salvas ficarão disponíveis para consultas futuras.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number instruction-marker">5</div>
                  <div className="instruction-text">
                    Para redefinir, clique em
                    {' '}
                    <b>&quot;Limpar filtros&quot;</b>
                    .
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}
